<template><section><h1>MessageBox 弹框</h1>
<p>模拟系统的消息提示框而实现的一套模态对话框组件，用于消息提示、确认消息和提交内容。</p>

<h3>消息提示</h3>
<demo-block>
                <div class="source" slot="source"><ayu-button @click="open()" type="primary">打开弹框</ayu-button>

</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open()"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span>&gt;</span>打开弹框<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    open() {
      <span class="hljs-keyword">this</span>.$alert({
        <span class="hljs-attr">title</span>: <span class="hljs-string">'我是标题'</span>,
        <span class="hljs-attr">content</span>: <span class="hljs-string">'我是内容'</span>,
        <span class="hljs-attr">onConfirm</span>: <span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
          alert(<span class="hljs-string">'你点了确定哦'</span>);
        }
      })
    },
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>确认消息</h3>
<demo-block>
                <div class="source" slot="source"><ayu-button @click="open2()" type="primary">打开弹框</ayu-button>

</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open2()"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span>&gt;</span>打开弹框<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    open2() {
      <span class="hljs-keyword">this</span>.$confirm({
        <span class="hljs-attr">title</span>: <span class="hljs-string">'我是标题'</span>,
        <span class="hljs-attr">content</span>: <span class="hljs-string">'我是内容'</span>,
        <span class="hljs-attr">onConfirm</span>: <span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
          alert(<span class="hljs-string">'你点了确定'</span>);
        },
        <span class="hljs-attr">onCancel</span>: <span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
          alert(<span class="hljs-string">'取消了哦'</span>);
        },
        <span class="hljs-attr">onClose</span>: <span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
          alert(<span class="hljs-string">'关闭了呢'</span>);
        }
      })
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">title</td>
<td style="text-align:left">标题</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">'标题'</td>
</tr>
<tr>
<td style="text-align:left">content</td>
<td style="text-align:left">内容</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">'一段内容'</td>
</tr>
<tr>
<td style="text-align:left">confirmButtonText</td>
<td style="text-align:left">确认按钮的文字</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">'确定'</td>
</tr>
<tr>
<td style="text-align:left">cancelButtonText</td>
<td style="text-align:left">取消按钮的文字</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">'取消'</td>
</tr>
<tr>
<td style="text-align:left">showCloseBtn</td>
<td style="text-align:left">是否显示关闭按钮</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left">true/false</td>
<td style="text-align:left">true</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">onConfirm</td>
<td style="text-align:left">点击确定触发该事件</td>
<td style="text-align:left"></td>
</tr>
<tr>
<td style="text-align:left">onCancel</td>
<td style="text-align:left">点击取消触发该事件</td>
<td style="text-align:left"></td>
</tr>
<tr>
<td style="text-align:left">onConfirm</td>
<td style="text-align:left">点击关闭触发该事件</td>
<td style="text-align:left"></td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  methods: {
    open() {
      this.$alert({
        title: '我是标题',
        content: '我是内容',
        onConfirm: () => {
          alert('你点了确定哦');
        }
      })
    },
    open2() {
      this.$confirm({
        title: '我是标题',
        content: '我是内容',
        onConfirm: () => {
          alert('你点了确定');
        },
        onCancel: () => {
          alert('取消了哦');
        },
        onClose: () => {
          alert('关闭了呢');
        }
      })
    }
  }
}
</script>